import i18n from 'config/i18n';
import * as Yup from 'yup';
import BusinessLocationsSelect from '../../components/select/BusinessLocationsSelect';
import { InputField } from '../../types';
import { CUSTOM } from '../index';

export type ProfileFieldsType = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  PGP_key: string;
};

export const profileFields: InputField[] = [
  {
    label: 'profile.formLabels.firstName',
    name: 'firstName',
    type: 'text',
    width: {
      desktop: 4,
      tablet: 6,
    },
  },
  {
    label: 'profile.formLabels.lastName',
    name: 'lastName',
    type: 'text',
    width: {
      desktop: 4,
      tablet: 6,
    },
  },
  {
    label: 'profile.formLabels.personal_phoneNumber',
    name: 'phonePrivate',
    type: 'tel',
    width: {
      desktop: 4,
      tablet: 6,
    },
  },
  {
    label: 'profile.formLabels.email',
    name: 'email',
    type: 'email',
    width: {
      desktop: 4,
      tablet: 6,
    },
  },
  {
    component: BusinessLocationsSelect,
    initialValue: [],
    label: 'profile.formLabels.address',
    name: 'businessLocationIds',
    type: CUSTOM,
    width: {
      desktop: 4,
      tablet: 6,
    },
  },
];

export const mobileProfileValidationSchema = Yup.object().shape({
  businessLocationIds: Yup.array()
    .of(Yup.string())
    .min(1, ({ min }) => i18n.t('validation:array.min', { min })),
  email: Yup.string()
    .required(() => i18n.t('validation:required'))
    .email(() => i18n.t('validation:string.email'))
    .max(255)
    .trim(),
  firstName: Yup.string()
    .required(() => i18n.t('validation:required'))
    .max(100)
    .trim(),
  lastName: Yup.string()
    .required(() => i18n.t('validation:required'))
    .max(200)
    .trim(),
  phonePrivate: Yup.string()
    .max(50)
    .matches(/^\+[1-9]\d{0,2}([ -]?\d+)+$/, () =>
      i18n.t('validation:string.phoneNumber')
    ),
});

export const headerTranslations = {
  content: 'profile.content',
  title: 'profile.title',
};

export const mobileProfileStep = {
  fields: profileFields,
  headerTranslations,
  key: 'profile',
  validationSchema: mobileProfileValidationSchema,
};
